<section id="add-user-container">
  <app-header title="Add User">
    <mat-toolbar class="filter-toolbar">
      <div class="user-search-toolbar">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Search the user directory</mat-label>
          <mat-icon matPrefix>search</mat-icon>
          <input
            matInput
            type="search"
            autocomplete="off"
            [formControl]="keywords" />
        </mat-form-field>
        <button
          mat-button
          type="button"
          [disabled]="!hasSearch"
          (click)="clearSearch()">
          Clear
        </button>
        @if (!loading && !loadError) {
          <span class="result-count" aria-live="polite">
            {{ users.length }} {{ users.length === 1 ? 'result' : 'results' }}
          </span>
        }
      </div>
    </mat-toolbar>
  </app-header>

  <div class="container add-user-results">
    @if (addError) {
      <p class="add-error" role="alert">{{ addError }}</p>
    }

    @if (loading) {
      <section class="directory-state" role="status" aria-live="polite">
        <mat-spinner diameter="44"></mat-spinner>
        <h2>Searching users</h2>
        <p>Please wait while the user directory is filtered.</p>
      </section>
    } @else if (loadError) {
      <section class="directory-state error-state" role="alert">
        <mat-icon>error_outline</mat-icon>
        <h2>User search failed</h2>
        <p>{{ loadError }}</p>
        <button mat-raised-button type="button" (click)="retrySearch()">
          Try again
        </button>
      </section>
    } @else if (users.length === 0) {
      <section class="directory-state" role="status">
        <mat-icon>person_search</mat-icon>
        <h2>No users found</h2>
        <p>
          @if (hasSearch) {
            Try a different name, HawkID, or email address.
          } @else {
            No directory users are available.
          }
        </p>
        @if (hasSearch) {
          <button mat-raised-button type="button" (click)="clearSearch()">
            Clear search
          </button>
        }
      </section>
    } @else {
      <section class="info-box">
        <h1 class="info-box-heading">Available Users</h1>
        <div class="info-box-wrapper">
          <div class="info-box-body">
            <mat-list class="info-box-list user-results-list">
              @for (user of users; track user.HawkId) {
                <mat-list-item class="user-result">
                  <h2 matListItemTitle>
                    {{ user.LastFirst }}
                    <span class="hawk-id">{{ user.HawkId }}</span>
                  </h2>
                  <p matListItemLine>
                    @if (user.Email) {
                      <span>{{ user.Email }}</span>
                    }
                    @if (user.Title || user.Department) {
                      <span>
                        {{ user.Title }}{{ user.Title && user.Department ? ', ' : ''
                        }}{{ user.Department }}
                      </span>
                    }
                  </p>
                  <div matListItemMeta class="user-result-action">
                    <button
                      mat-raised-button
                      type="button"
                      [disabled]="!!addingHawkId"
                      (click)="addUser(user)">
                      <mat-icon>person_add</mat-icon>
                      <span>
                        {{ addingHawkId === user.HawkId ? 'Adding…' : 'Add' }}
                      </span>
                    </button>
                  </div>
                </mat-list-item>
              }
            </mat-list>
          </div>
        </div>
      </section>
    }
  </div>
</section>
